import React from 'react';
import ReportTagButton from './ReportTagButton';

interface TagEntry {
  tag: string;
  count: number;
  type: 'positive' | 'negative';
}

interface RecapPlayerCardProps {
  matchId: string;
  playerId: string;
  name: string;
  avatar?: string | null;
  topTags: TagEntry[];
  onReportAutoHidden?: () => void;
}

const POSITIVE_BG = 'rgba(76,175,80,0.15)';
const POSITIVE_FG = '#4CAF50';
const NEGATIVE_BG = 'rgba(244,67,54,0.15)';
const NEGATIVE_FG = '#F44336';

export default function RecapPlayerCard({ matchId, playerId, name, avatar, topTags, onReportAutoHidden }: RecapPlayerCardProps) {
  const initials = name.trim().slice(0, 2).toUpperCase();
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
      <div style={{ width: 44, height: 44, borderRadius: '50%', overflow: 'hidden', background: '#222', flexShrink: 0 }}>
        {avatar ? (
          <img src={avatar} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 14, fontWeight: 700 }}>
            {initials}
          </div>
        )}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ margin: 0, fontSize: 15, fontWeight: 600, color: '#fff' }}>{name}</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 6 }}>
          {topTags.length === 0 && (
            <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>Sin tags</span>
          )}
          {topTags.map((t) => {
            const isPos = t.type === 'positive';
            return (
              <span key={`${t.type}:${t.tag}`} style={{ display: 'inline-flex', alignItems: 'center' }}>
                <span
                  style={{
                    fontSize: 12,
                    padding: '4px 8px',
                    borderRadius: 12,
                    background: isPos ? POSITIVE_BG : NEGATIVE_BG,
                    color: isPos ? POSITIVE_FG : NEGATIVE_FG,
                    fontWeight: 600,
                  }}
                >
                  {t.tag} ×{t.count}
                </span>
                {!isPos && (
                  <ReportTagButton
                    matchId={matchId}
                    reviewedPlayerId={playerId}
                    tagText={t.tag}
                    onAutoHidden={onReportAutoHidden}
                  />
                )}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
}
